import { Box, Typography } from "@mui/material";
import { useTranslation } from "i18n-fe";
import { LIST_MODE, buildLookupRideList } from "../utils/lookupRideList";
import LookupRideRow from "./LookupRideRow";

// #3394 -- the one merged ride list (results + rides) of the look-up column.
// Division headers are plain rows of the list, not sticky: they scroll with the
// rides. A class without divisions renders flat. The scrolling itself belongs
// to LookupColumn's `lookup-scroll` box, the ONLY scroller of the column.
export default function LookupRideList({
  classId,
  rideRows,
  results,
  placed,
  placedByDivision = false,
  currentRideId,
  loading,
  isFinal,
}) {
  const { t } = useTranslation("announcer");
  // `placed` is resolved once by LookupColumn (summary OR all results FINAL).
  const list = buildLookupRideList({ rideRows, results, placed, currentRideId, placedByDivision });
  const placedList = list.mode === LIST_MODE.PLACED;
  const renderRow = (entry) => (
    <LookupRideRow key={entry.row.id} entry={entry} placedList={placedList} t={t} />
  );
  return (
    <Box
      data-testid="lookup-ride-list"
      data-class-id={classId}
      data-mode={list.mode}
      data-final={isFinal || undefined}
    >
      {rideRows.length === 0 && loading && (
        <Typography
          data-testid="lookup-ride-list-loading"
          role="status"
          variant="body2"
          color="text.secondary"
          sx={{ px: 1.5, py: 1 }}
        >
          {t("lookupColumn.ridesLoading")}
        </Typography>
      )}
      {list.groups
        ? list.groups.map((group) => (
            <Box key={group.token} data-testid="lookup-division-group" data-division-token={group.token}>
              <Typography
                data-testid="lookup-division-heading"
                variant="overline"
                // The division is shown as stored ("Jr/YR"), not shouted: MUI's
                // overline is caseAllCaps (see ClassResults' #2634 AC5 note).
                sx={{
                  display: "block",
                  px: 1.5,
                  pt: 1,
                  pb: 0.25,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  color: "text.secondary",
                  textTransform: "none",
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                {group.label || t("results.divisionOpen")}
              </Typography>
              {group.entries.map(renderRow)}
            </Box>
          ))
        : list.entries.map(renderRow)}
    </Box>
  );
}
